module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.row.start.current_show_type == 1) ? _c('ScoreStartList2', {
    attrs: {
      "row": _vm.row.start,
      "list": _vm.row.list
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.start.current_show_type == 2) ? _c('ScoreStartArmy2', {
    attrs: {
      "row": _vm.row.start,
      "list": _vm.row.list,
      "start": _vm.row.start.subject
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.start.current_show_type == 3) ? _c('ScoreStartRank2', {
    attrs: {
      "row": _vm.row.start,
      "list": _vm.row.list,
      "start": _vm.row.start.subject
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.start.current_show_type == 4) ? _c('ScoreStartSubjectRank2', {
    attrs: {
      "row": _vm.row.start,
      "start": _vm.row.start.subject,
      "list": _vm.row.rank_list
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b7a703c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/ScoreShow.vue
// module id = 2462
// module chunks = 0